var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"primary--text",staticStyle:{"font-size":"30px","text-align":"center"}},[_vm._v(" Coming soon..."),_c('v-icon',{attrs:{"color":"primary","size":"30"}},[_vm._v("mdi-run")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }